<template>
  <section class="custom-container my-1" v-if="showProducts.length">
    <h2 class="text-center font-lg font-bold mt-4 mb-2">{{ infoProducts.title ?? ''}}</h2>
    <p class="my-1">{{ infoProducts.description ?? '' }}</p>

    <div
      ref="carousel"
      class="store-carousel"
      @mouseenter="pauseAutoSlide"
      @mouseleave="startAutoSlide"
    >
      <div
        :class="[isMobile ? 'carousel-track' : 'row center gap-16']"
        :style="{ transform: `translateX(-${scrollX}px)` }"
      >
        <div
          v-for="(option, index) in showProducts"
          :key="option.id ?? index"
          class="product-container"
        >
          <a
            :href="option.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              class="store-icon"
              :src="option.img"
              :alt="option.store_name || 'Imagen del producto'"
              loading="lazy"
              width="200px"
              height="200px"
            />
          </a>

          <a
            class="btn-primary flat"
            :href="option.url"
            target="_blank"
            rel="noopener noreferrer"
          >Comprar</a>

          <div class="flex-column gap-8 mt-1">
            <div v-if="option.oldPrice">
              <span class="text-xs weight-500 strikethrough">
                {{ formatCurrency(option.oldPrice) }}
              </span>
            </div>

            <div class="w-100">
              <span class="text-xs weight-500">
                Precio: 
              </span>
              <span class="price-text weight-500">{{ formatCurrency(option.price) }}</span>
            </div>

            <span class="text-caption pre-line" style="line-height: 1.4;">
              {{ option.description  }}
            </span>

            <Rating v-model="option.rate" size="14px"></Rating>

            <DateRangeDisplay
              :startDate="formatDate(option.date)"
              :finishDate="formatDate(option.finish_date)"
            ></DateRangeDisplay>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useScreen } from '../../composables/useScreen'
import DateRangeDisplay from '../../global-components/DateRangeDisplay.vue'
import Rating from '../../global-components/Rating.vue'

export default {
  components: {
    Rating,
    DateRangeDisplay
  },
  props: {
    info: {
      type: String,
      required: true
    }
  },
  setup () {
    const {isMobile} = useScreen()
    return {isMobile}
  },
  data () {
    return {
      infoProducts: {
        products: []
      },
      scrollX: 0,
      intervalId: null,
      step: 0
    }
  },
  computed: {
    showProducts () {
      const today = new Date();
      return this.infoProducts.products.filter(product => {
        const start = new Date(product.date);
        const end = new Date(product.finish_date);
        return today >= start && today <= end;
      });
    }
  },
  methods: {
    startAutoSlide() {
      if (!this.isMobile) return;
      if (this.intervalId) return;
      if (!this.$refs.carousel) return;

      const carouselWidth = this.$refs.carousel.offsetWidth;

      this.intervalId = setInterval(() => {
        const track = this.$refs.carousel.querySelector('.carousel-track');
        const trackWidth = track.scrollWidth;

        this.scrollX += carouselWidth;
        this.step++;

        if (this.scrollX >= trackWidth / 2) {
          this.scrollX = 0;
          this.step = 0;
        }
      }, 4000);
    },
    pauseAutoSlide() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    formatCurrency(value) {
      if (!value) return '';
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'USD' }).format(value);
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    }
  },
  beforeUnmount() {
    this.pauseAutoSlide();
  },
  created () {
    try {
      this.infoProducts = JSON.parse(this.info);
    } catch (e) {
      this.infoProducts = { products: [] };
    }
  },
  mounted () {
    if (this.isMobile) {
      this.startAutoSlide();
    }
  }
}
</script>

<style scoped>
.store-carousel {
  overflow-y: auto;
  position: relative;
  width: 100%;
  margin-top: 1rem;
}

.carousel-track {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.6s ease-in-out;
  gap: 16px;
}

.store-icon {
  height: 200px;
  flex-shrink: 0;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.store-icon:hover {
  transform: scale(1.1);
}

.product-container {
  padding: 8px;
  max-width: 216px;
}

.text-xs {
  font-size: 14px;
}
.price-text {
  font-size: 16px;
}

.weight-500 {
  font-weight: 500;
}

.pre-line {
  white-space: pre-line;
}

.strikethrough {
  text-decoration: line-through;
}
</style>
